import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../axiosConfig";
import { Container, Form, Button, Table } from "react-bootstrap";
function EditInvoice() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [products, setProducts] = useState([]);
  //   useEffect(() => {
  //     api.get(`/invoices/${id}`)
  //       .then(res => setInvoice(res.data))
  //       .catch(err => {
  //         console.error('Eroare la preluare factură:', err);
  //         alert('Factura nu a fost găsită.');
  //         navigate('/invoices');
  //       });
  //   }, [id, navigate]);

  useEffect(() => {
  api.get("/products")
    .then(res => setProducts(res.data))
    .catch(err => console.error("Eroare la încărcare produse", err));
}, []);

  useEffect(() => {
    api
      .get(`/invoices/${id}`)
      .then((res) => {
        console.log("Factura cu linii:", res.data);
        const total = recalcTotal(res.data.lines);
        setInvoice({ ...res.data, total });
        setInvoice(res.data);
        
      })
      .catch((err) => {
        console.error("Eroare la preluare factură:", err);
        alert("Factura nu a fost găsită.");
        navigate("/invoices");
      });
  }, [id, navigate]);

  const handleChange = (e) => {
    const updatedLines = [...invoice.lines];
       const total = recalcTotal(updatedLines);

        //setInvoice({ ...invoice, lines: updatedLines, total });

    setInvoice({ ...invoice, [e.target.name]: e.target.value, lines: updatedLines, total });
  };

const recalcTotal = (lines) => {
  let total = 0;

  for (const line of lines) {
    const qty = parseFloat(line.quantity) || 0;
    const price = parseFloat(line.price) || 0;
    total += qty * price;
  }

  return total.toFixed(2);
};


const handleSave = () => {
  if (!invoice) return;

  const cleanedLines = (invoice.lines || []).map(line => ({
    product_id: line.product_id,
    quantity: parseFloat(line.quantity),
    price: line.price,
    tva_rate: line.tva_rate,
  }));

  const payload = {
    date: invoice.date,
    due_date: invoice.due_date,
    total: invoice.total,
    lines: cleanedLines,
  };
    api.put(`/invoices/${id}`, payload)
  .then(() => {
    alert('Factura a fost actualizată!');
    navigate('/invoices');
  })
  .catch(err => {
    console.error('Eroare la salvare:', err);
    alert('Actualizarea a eșuat.');
  });
  };

const handleLineChange = (index, field, value) => {
  const updatedLines = [...invoice.lines];

  // Conversie numerică automată pentru câmpuri numerice
  const numericFields = ["quantity", "price", "tva_rate", "product_id"];
  const parsedValue = numericFields.includes(field) ? parseFloat(value) || 0 : value;

  updatedLines[index][field] = parsedValue;

  // recalculează total
  const total = recalcTotal(updatedLines);
  setInvoice({ ...invoice, lines: updatedLines, total });
};

//   if (field === "product") {
//     const selectedProduct = products.find(p => p.id === Number(value));
//     if (selectedProduct) {
//       updatedLines[index] = {
//         ...updatedLines[index],
//         product: selectedProduct,
//         product_id: selectedProduct.id,
//         price: selectedProduct.price,
//         tva_rate: selectedProduct.tva_rate
//       };
//       const total = recalcTotal(updatedLines);

//         setInvoice({ ...invoice, lines: updatedLines, total });

//     }
//   } else {
//     updatedLines[index][field] = value;
//   }

//   setInvoice({ ...invoice, lines: updatedLines });
// };


  const addLine = () => {
    const newLine = {
      id: null, // sau undefined
      product_id: "",
      quantity: "",
      price: "",
      tva_rate: 0.19,
    };

    const updatedLines = [...invoice.lines, newLine];
    const total = recalcTotal(updatedLines);
    setInvoice({ ...invoice, lines: updatedLines, total });
    // setInvoice({ ...invoice, lines: [...invoice.lines, newLine] });
  };

  const removeLine = (index) => {
    const updatedLines = [...invoice.lines];
    updatedLines.splice(index, 1); // elimină linia de pe poziția index
    setInvoice({ ...invoice, lines: updatedLines });
  };

  if (!invoice) return <div>Se încarcă...</div>;

  return (
    <Container className="mt-4">
      <h3>Editare Factură #{id}</h3>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Data</Form.Label>
          <Form.Control
            type="date"
            name="date"
            value={invoice.date}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Scadență</Form.Label>
          <Form.Control
            type="date"
            name="due_date"
            value={invoice.due_date}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Total</Form.Label>
          <Form.Control
            type="number"
            name="total"
            value={invoice.total}
            onChange={handleChange}
          />
        </Form.Group>

        {invoice.lines?.length > 0 && (
          <div className="mb-3">
            <h5>Linii factură</h5>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>#</th>
                  <th>ID Produs</th>
                  <th>Denumire</th>
                  <th>Cantitate</th>
                  <th>Preț</th>
                  <th>TVA</th>
                  <th>Acțiuni</th> {/* 👈 nouă coloană */}
                </tr>
              </thead>
              <tbody>
                {invoice.lines.map((line, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <Form.Control
                        type="text"
                        value={line.product_id}
                        onChange={(e) =>
                          handleLineChange(index, "product_id", e.target.value)
                        }
                      />
                    </td>

                    <td>
  <Form.Select
    value={line.product?.id || line.product_id}
    onChange={(e) => handleLineChange(index, "product", e.target.value)}
  >
    <option value="">-- Selectează produs --</option>
    {products.map((prod) => (
      <option key={prod.id} value={prod.id}>
        {prod.name}
      </option>
    ))}
  </Form.Select>
</td>

                   
                    <td>
                      <Form.Control
                        type="number"
                        value={line.quantity}
                        onChange={(e) =>
                          handleLineChange(index, "quantity", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        value={line.price}
                        onChange={(e) =>
                          handleLineChange(index, "price", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Form.Control
                        type="number"
                        step="0.01"
                        value={line.tva_rate}
                        onChange={(e) =>
                          handleLineChange(index, "tva_rate", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => removeLine(index)}
                      >
                        🗑
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>

            <Button variant="secondary" size="sm" onClick={addLine}>
              + Adaugă linie
            </Button>
          </div>
        )}

        <Button variant="primary" onClick={handleSave}>
          Salvează
        </Button>
      </Form>
    </Container>
  );
}

export default EditInvoice;
